import React from "react";
import ReactDOM from "react-dom/client";
import { DotBotsAuth } from "@dotbots-boutique/auth-sdk";
import { DotBotsAuthProvider } from "@dotbots-boutique/auth-sdk/react";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ConfirmProvider } from "./components/ConfirmModal";
import "./i18n";
import "./styles.css";

const auth = new DotBotsAuth({
  appId: import.meta.env.VITE_DOTBOTS_APP_ID,
  apiUrl: import.meta.env.VITE_PLATFORM_API_URL,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <DotBotsAuthProvider auth={auth}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </DotBotsAuthProvider>
  </React.StrictMode>,
);
